import { SurveyData } from './survey.types';
import { Response } from './response';
import { Xid } from '@/utils/xid';
import { parseJSON } from 'date-fns';

export class Survey implements SurveyData {
  readonly id?: string;
  readonly name?: string;
  readonly isActive?: boolean;
  readonly dateCreated?: Date | string;
  readonly dateUpdated?: Date | string;
  readonly definition?: any;
  readonly responses?: Response[];

  constructor(data: SurveyData, clientSide = true) {
    if (data.id) {
      this.id = data.id;
    } else {
      this.id = Xid.generateId();
    }
    this.name = data.name;
    this.isActive = data.isActive;
    data.dateCreated
      ? (this.dateCreated = parseJSON(data.dateCreated))
      : (this.dateCreated = new Date());
    data.dateUpdated
      ? (this.dateUpdated = parseJSON(data.dateUpdated))
      : undefined;

    if (clientSide) {
      this.definition = JSON.stringify(data.definition, null, '\t');
    } else {
      this.definition = JSON.parse(data.definition);
    }
    
    if (data.responses) {
      this.responses = data.responses.map(item => new Response(item));
    } else {
      this.responses = [];
    }

  }
}
